const translations = {
    continueCta: 'Continue →',
    dropZoneCta: 'Drop files or click to browse',
    dropZoneCtaProcessing: 'Reading shapefile...',
    dropZoneFormats: '.shp + .shx + .dbf + .prj  ·  or a single .zip',
    errorApplicationFailed: 'Could not create application',
    errorBoundaryFailed: 'Could not compute field boundary from zones',
    errorCrs: 'Shapefile coordinate system not supported: {{detected}}. Please reproject to WGS84.',
    errorInvalidPolygons: '{{count}} polygons are invalid and cannot be used.',
    errorParseFailed: 'Could not read shapefile: {{message}}',
    errorPrescriptionFailed:
        'Application created, but prescription storage failed. You can re-attach from the Flight Planner.',
    gapPolicyBaseRate: 'Use base rate',
    gapPolicyMask: 'Skip gaps',
    pageCancel: 'Cancel',
    pageEyebrow: 'Variable rate application',
    pageSubtitle:
        "Drop a shapefile bundle exported from John Deere Operations Center, FieldView, or any other VRA tool. We'll compute the field boundary, attach the prescription, and pre-build the flight plan.",
    pageSupport: 'Support',
    pageTitle: 'Import a prescription',
    pageTopBarTitle: 'New from prescription',
    previewApproxArea: 'Approximate field area',
    previewAreaValue: '{{hectares}} ha',
    previewCrs: 'Coordinate system',
    previewCrsValue: 'WGS84 {{check}}',
    previewFile: 'File',
    previewRateColumn: 'Rate column',
    previewRateRange: 'Rate range',
    previewRateSingle: 'Single rate · {{rate}} {{unit}}',
    previewRateSpan: '{{min}}–{{max}} {{unit}}',
    previewZones: 'Zones',
    railBoundaryEmptyBody:
        'The boundary will be computed automatically from the union of all zones in the shapefile. You can edit it later.',
    railBoundaryReadyBoundingBoxLabel: 'Bounding box',
    railBoundaryReadyBoundingBoxValue: '{{width}}m × {{height}}m',
    railBoundaryReadyCentroidLabel: 'Centroid',
    railBoundaryReadyCentroidValue: '{{lat}} N, {{lng}} W',
    railBoundaryReadyZonesLabel: 'Zones merged',
    railBoundaryReadyZonesValue: '{{count}} → 1',
    railBoundaryTitle: 'Field boundary',
    railNextBody:
        "After upload, you'll be taken to the Flight Planner where you can fine-tune coverage, spray settings, and headlands before saving.",
    railNextReadyBody:
        'Click Continue to create the application and open the Flight Planner with this prescription attached.',
    railNextReadyTitle: 'Next steps',
    railNextTitle: "What's next",
    rateColumnConfirm: 'Use this column',
    rateColumnHint: 'Choose the .dbf column that holds the application rate.',
    rateColumnLabel: 'Rate column',
    replaceFileCta: 'Replace file',
    section1EmptyHint: 'All four files at once, or a single .zip bundle.',
    section1EmptyTitle: 'Upload your shapefile',
    section1FilledTitle: 'Shapefile loaded',
    section2Eyebrow: 'Step 2',
    section2Hint: 'What should the drone do for areas not covered by the prescription?',
    section2Title: 'Outside zones',
    sectionEyebrowStep1: 'Step 1',
    submittingCta: 'Creating...',
    supportOrgPlaceholder: 'Org 1',
    warningDismiss: 'Dismiss',
    warningTitle: 'Shapefile cannot be used'
};

export default translations;
